import { Route } from 'mobx-router'

import { HomePage } from './pages/HomePage/HomePage'

import { LoginScreen } from './components/auth/LoginScreen'
import { SignupScreen } from './components/auth/SignupScreen'
import { ChecklistPage } from './pages/ChecklistPage/ChecklistPage'
import { SettingsPage } from './pages/SettingsPage'
import { TemplatePage } from './pages/TemplatePage.ts/TemplatePage'
import { TemplateReorderPage } from './pages/TemplateReorderPage/TemplateReorderPage'
import { RootRouterStore } from './store/RootRouterStore'

export const routes = {
  signup: new Route({
    path: '/auth/signup',
    component: <SignupScreen />,
  }),
  login: new Route({
    path: '/auth/login',
    component: <LoginScreen />,
  }),
  home: new Route({
    path: '/',
    component: <HomePage />,
  }),
  checklist: new Route({
    path: '/checklist/:id',
    component: <ChecklistPage />,
  }),
  template: new Route({
    path: '/template/:id',
    component: <TemplatePage />,
  }),
  templateReorder: new Route({
    path: '/template/:id/reorder',
    component: <TemplateReorderPage />,
  }),
  settings: new Route({
    path: '/settings',
    component: <SettingsPage />,
  }),
  signIn: new Route({
    path: '/sign-in',
    component: <LoginScreen />,
  }),
}

export const store = new RootRouterStore(routes)

export function startRouter() {
  // startMobxRouter(routes, store)
  store.startRouter()
}
